module.exports = __webpack_public_path__ + "img/grey-dot.f9b3a35b.svg";